import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Page from './page';
import Loader from './Loader';
import Api from '../../util/api';
import Button from './Button';
import {useDispatch} from 'react-redux';
import {navigateNext} from '../../action/actions';
import ResultToolResultSet from '../../util/ResultToolResultSet';
import {publicBuildUrl} from '../../config/config';

const ResultTool = ({id, questions, texts}) => {
    const [data, setData] = useState(null);
    const [step, setStep] = useState(0);
    const dispatch = useDispatch();

    const handleStepNext = () => setStep(step < 6 ? (step + 1) : 6);
    const handleStepPrevious = () => setStep(step > 1 ? (step - 1) : 0);

    useEffect(() => {
        const fetchData = async () => {
            let response = await Api.getData(id);

            setData(ResultToolResultSet.fromResponse(response));
        }

        fetchData().then();
        // eslint-disable-next-line
    }, [])

    if (data === null) {
        return <Page title={'Loading'}>Loading ...</Page>;
    }

    const handleNext = () => {
        if (step <= 5) {
            handleStepNext();
        } else {
            Api.navigateDeviceNext().then(
                () => dispatch(navigateNext())
            );
        }
    }

    return (
        <Page title={'Target Group Selection'}>
            <div className={'bodyContainer'} style={{justifyContent: 'center'}}>
                <div style={styles.container}>
                    <div style={styles.title}>{questions[step]}</div>

                    <div style={{}}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '25px',
                            justifyContent: 'center',
                        }}>
                            <div style={{
                                cursor: 'pointer',
                                marginRight: '25px',
                                width: '47px',
                            }} onClick={handleStepPrevious}>
                                {step > 0 &&
                                <img src={`${publicBuildUrl}icons/IconBack.png`} alt={'Previous'} style={{marginTop: '7px'}}/>}
                            </div>

                            <img src={`${publicBuildUrl}images/Stars` + (step + 1) + '.png'} alt={'progres in stars'}
                                 style={{marginRight: '25px'}}/>

                            <div style={{
                                cursor: 'pointer',
                            }} onClick={handleStepNext}>
                                {step < 5 &&
                                <img src={`${publicBuildUrl}icons/IconForward.png`} alt={'Previous'} style={{marginTop: '7px'}}/>}
                            </div>
                        </div>
                        <div style={{
                            color: '#003d4c',
                            display: 'flex',
                            fontFamily: 'Ubuntu',
                            fontWeight: 500,
                            fontSize: '20px',
                            justifyContent: 'center',
                            marginBottom: '80px',
                        }}>
                            <div style={{
                                textAlign: 'center'
                            }}>
                                {step < 6 && texts[step].split('\n').map((item, key) => (<span key={key}>{item}<br/></span>))}
                            </div>
                        </div>
                    </div>
                    {step < 6 &&
                    <div style={styles.resultContainer}>
                        <div style={styles.columnLeft}>
                            <img src={`${publicBuildUrl}images/MiroTool` + (step + 1) + '.png'} alt={'Miro'} style={{width: '100%'}}/>
                        </div>
                        <div style={styles.columnRight}>
                            {step < 6 &&
                                <>
                                    <div style={styles.question}>
                                    </div>

                                    <div style={{
                                        ...styles.option,
                                        opacity: .5
                                    }}>
                                        <img src={`${publicBuildUrl}icons/IconOk.png`}
                                             style={styles.optionImage} alt={'OK'}/>
                                        <Loader color={'green'} loaded={data[step]['OK']}/>
                                    </div>

                                    <div style={styles.option}>
                                        <img src={`${publicBuildUrl}icons/IconNokSelected.png`}
                                             style={styles.optionImage} alt={'OK'}/>
                                        <Loader color={'red'} loaded={data[step]['NOK']}/>
                                    </div>
                                </>}

                            {step === 6 &&
                                <div style={{
                                    color: '#003d4c',
                                    display: 'flex',
                                    flexGrow: 1,
                                    fontFamily: 'Ubuntu',
                                    fontWeight: 500,
                                    fontSize: '20px',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                    <div style={{
                                        textAlign: 'justify'
                                    }}>
                                        {texts[6].split('\n').map((item, key) => (<span key={key}>{item}<br/></span>))}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>}

                    {step === 6 &&
                    <div style={styles.resultContainer}>
                        <div style={styles.columnLeft}>
                            <img src={`${publicBuildUrl}images/MiroToolSad.png`} alt={'Miro'} style={{width: '100%'}}/>
                        </div>
                        <div style={styles.columnRight}>
                            <div style={{
                                color: '#003d4c',
                                display: 'flex',
                                flexGrow: 1,
                                fontFamily: 'Ubuntu',
                                fontWeight: 500,
                                fontSize: '20px',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                            }}>
                                <div>
                                    {texts[6].split('\n').map((item, key) => (<span key={key}>{item}<br/></span>))}
                                </div>
                            </div>
                        </div>
                    </div>}


                    <div style={{marginTop: '120px', width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
                        <div style={{width: '150px'}}>
                            <Button onClick={handleNext} color={'pink'} text={'Volgende'}/>
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    );
}

ResultTool.propTypes = {
    id: PropTypes.number.isRequired,
    questions: PropTypes.arrayOf(PropTypes.string).isRequired,
    texts: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '960px',
    },
    resultContainer: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
    },
    columnLeft: {
        display: 'flex',
        width: 'calc(25% - 25px)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    columnRight: {
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(75% - 25px)',
    },
    title: {
        borderBottom: '9px solid #68c4d6',
        color: '#e4195f',
        display: 'flex',
        justifyContent: 'center',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        fontSize: '48px',
        fontStyle: 'italic',
        lineHeight: '48px',
        paddingBottom: '25px',
        marginBottom: '25px',
        width: '100%',
        textAlign: 'center',
    },
    question: {
        color: '#427A83',
        width: '100%',
        fontFamily: 'Ubuntu',
        fontWeight: 'bold',
        fontSize: '22px',
        marginBottom: '25px',
        textAlign: 'center',
    },
    option: {
        display: 'flex',
        marginBottom: '25px',
        alignItems: 'center',
    },
    optionImage: {
        width: '50px',
        marginRight: '10px'
    },
}

export default ResultTool;
